package com.bulut.mecitogullari.data.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import kotlinx.serialization.Serializable

/** Contractor/company profile stored on the user's root Firestore document. */
interface ProfileRepository {
    val companyName: Flow<String>
    suspend fun setCompanyName(name: String)
}

@Serializable
internal data class ProfileDoc(val companyName: String = "")

class FirestoreProfileRepository : ProfileRepository {

    @OptIn(ExperimentalCoroutinesApi::class)
    override val companyName: Flow<String> =
        Firebase.auth.authStateChanged.flatMapLatest { user ->
            if (user == null) {
                flowOf("")
            } else {
                userDoc(user.uid).snapshots.map { snapshot ->
                    if (snapshot.exists) {
                        runCatching { snapshot.data<ProfileDoc>() }.getOrNull()?.companyName ?: ""
                    } else {
                        ""
                    }
                }
            }
        }

    override suspend fun setCompanyName(name: String) {
        val uid = currentUid() ?: return
        userDoc(uid).set(ProfileDoc(companyName = name))
    }
}
